import { render, staticRenderFns } from "./userQydz.vue?vue&type=template&id=8b1f7878&scoped=true&"
import script from "./userQydz.vue?vue&type=script&lang=js&"
export * from "./userQydz.vue?vue&type=script&lang=js&"
import style0 from "./userQydz.vue?vue&type=style&index=0&id=8b1f7878&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1f7878",
  null
  
)

export default component.exports